import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/services/common/alert.service';
import { LoginService } from '../login/login.service';
import { first } from 'rxjs';
import { StorageKey, StorageService } from 'src/app/services/common/storage.service';

@Component({
  selector: 'app-approve-store-campaign',
  templateUrl: './approve-store-campaign.component.html',
  styleUrls: ['./approve-store-campaign.component.scss']
})
export class ApproveStoreCampaignComponent implements OnInit {

  queryString = Object();

  model: any;
  constructor(private alertService: AlertService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private storageService: StorageService,
    private loginService: LoginService,) { }

  ngOnInit() {
    this.queryString = this.activatedRoute.snapshot.queryParams;

    if (this.queryString?.approveToken) {
      var approveToken = this.queryString?.approveToken;
      var decrypt = window.atob(approveToken)
      this.model = JSON.parse(decrypt);

      let location: any;
      if (this.model.campaignDetail.country) {
        location = this.model.campaignDetail.country;
      }
      if (this.model.campaignDetail.state) {
        location = location + ", " + this.model.campaignDetail.state;
      }
      if (this.model.campaignDetail.city) {
        location = location + ", " + this.model.campaignDetail.city;
      }

      this.model.campaignDetail.location = location;

      if (this.model?.campaignDetail.offerType) {
        if (this.model?.campaignDetail.offerType == "BUYGET") {
          this.model.campaignDetail.offerTypeTitle = "Buy " + this.model.campaignDetail.mainProductCount + " Get " + this.model.campaignDetail.freeProductCount;
        }
        else if (this.model?.campaignDetail.offerType == "FLAT") {
          this.model.campaignDetail.offerTypeTitle = "Flat " + this.model.campaignDetail.currencySymbol + this.model.campaignDetail.couponValue;
        }
        else if (this.model?.campaignDetail.offerType == "FREESAM") {
          this.model.campaignDetail.offerTypeTitle = this.model?.campaignDetail.offerTypeName;
        }
        else if (this.model?.campaignDetail.offerType == "GIFTVC") {
          this.model.campaignDetail.offerTypeTitle = this.model?.campaignDetail.offerTypeName + ' ' + this.model.campaignDetail.currencySymbol + this.model.campaignDetail.couponValue;
        }
        else if (this.model?.campaignDetail.offerType == "DISCOUNT") {
          this.model.campaignDetail.offerTypeTitle = "Discount " + this.model.campaignDetail.couponValue + "%";
        }
        else {
          this.model.campaignDetail.offerTypeTitle = this.model?.campaignDetail.offerTypeName;
        }
      }

      this.storageService.setValue(StorageKey.authToken, this.model.adminToken);
    }
    else {
      this.alertService.showError("Invalid link");
      this.router.navigate(['login']);
    }
  }

  onClickConfirm() {
    this.loginService.stote_campaign_approve(this.model.id).pipe(first()).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.storageService.removeValue(StorageKey.authToken);
          this.router.navigate(['login']);
        }
      }
    });
  }
}